import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { trackEvent } from '../../backend/tracking';
import { useAuth } from '../../contexts/Auth';

export default function PublicOutlet() {
    const location = useLocation();
    const { isLoggedIn } = useAuth();

    useEffect(() => {
        if (isLoggedIn) {
            trackEvent("pageview", { page: `${location.pathname}${location.search}` });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return <Outlet />;
}